module.exports = __webpack_public_path__ + "static/media/appTemplate3.c31fa720.gif";